export default __webpack_public_path__ + "static/media/Beard_2_C2.5b43c817.svg";